import { SearchAutocomplete } from 'app/components/layouts/SearchAutocomplete';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import * as vocabularyApi from 'app/requests/vocabularies';
import { vocabularyUrlSlug } from 'app/utils/string';
import { useTranslation } from 'next-i18next';
import { Vocabulary } from 'types/vocabulary';
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const VocabularySearch = () => {
  const router = useRouter()
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [params, setParams] = useState({
    limit: 10,
    keyword: '',
    xml: true,
    sort_column: 'word',
    direction: 'asc',
  });

  useEffect(() => {
    if (params.keyword) {
      getVocabularies();
    }
  }, [params.keyword])

  const getVocabularies = async () => {
    const vocabularies = await vocabularyApi.list(params, { selects: {
      word: 1,
      slug: 1,
    }});

    setItems(
      (vocabularies?.data || []).map((vocabulary: Vocabulary) => {
        return {
          id: vocabulary.slug,
          name: vocabulary.word,
        }
      })
    );
  }

  const handleOnSearch = (keyword: string) => {
    setParams({
      ...params, keyword
    })
  }

  const handleOnSelect = (item) => {
    router.push(`/vocabularies/${vocabularyUrlSlug(item.id, router?.locale)}`)
  }

  const handleSearch = () => {
    if (params.keyword) {
      router.push(`/vocabularies/${vocabularyUrlSlug(params.keyword, router?.locale)}`)
    }
  }

  return (
    <>
      <div className="input-search">
        <SearchAutocomplete
          items={items}
          placeholder={`${t('actions.search')}...`}
          onSearch={handleOnSearch}
          onSelect={handleOnSelect}
          autoFocus={false}
        />
      </div>
      <button
        onClick={() => handleSearch()}
        className={`btn btn-default button-search py-2 rounded-circle`}
        aria-label="search button"
        style={{ background: '#0077c8'}}
        type="button"
      >
        <FontAwesomeIcon className="icon-redirect" icon={faSearch} />
      </button>
    </>
  )
}

export default VocabularySearch
